import UnrecoverableError from "./unrecoverable-error-view";
export default UnrecoverableError;
